module.exports = __webpack_public_path__ + "our_story.png?340204e9e07d9886293a7c903bb9e763";


//////////////////
// WEBPACK FOOTER
// ./src/static/headers/our_story.png
// module id = 15
// module chunks = 0